// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a59ed8e8","977":"8be563a3"}[chunkId] + ".chunk.js";
};